import { createContext, ReactNode, useContext } from 'react';

import { Me } from '@/pages/members/types';
import { AppMessage } from '@/types/appMessage';

export interface MembersContextState {
  addMessage(level: AppMessage['level'], text: string): void;
  addMessage(message: AppMessage): void;
  addMessage(messages: AppMessage[]): void;
  onboardingCompleted: boolean;
  host: string;
  env: string;
  memberData: Me;
  setMemberData: (data: Me) => void;
  isRunningInReactNativeWebView: boolean;
  getMemberFullName(withPronouns: boolean, withNickname: boolean): string;
  getMemberPublicName(): string;
}

export const MembersContext = createContext<MembersContextState>({} as MembersContextState);

export function MembersContextProvider({
  value,
  children
}: {
  value: MembersContextState;
  children: ReactNode;
}) {
  return <MembersContext.Provider value={value}>{children}</MembersContext.Provider>;
}

export function useMembersContext() {
  return useContext(MembersContext);
}
